import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: { Authorization: `Bearer ${token}` }
  };
};

/**
 * Get all rebates with filters
 */
export const getRebates = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.company_id) params.append('company_id', filters.company_id);
  if (filters.rebate_type) params.append('rebate_type', filters.rebate_type);
  if (filters.rebate_year) params.append('rebate_year', filters.rebate_year);
  if (filters.start_date) params.append('start_date', filters.start_date);
  if (filters.end_date) params.append('end_date', filters.end_date);

  const queryString = params.toString();
  const url = `${API_URL}/wholesale/rebates${queryString ? `?${queryString}` : ''}`;
  
  const response = await axios.get(url, getAuthHeaders());
  return response.data;
};

/**
 * Get rebate by ID
 */
export const getRebateById = async (id) => {
  const response = await axios.get(`${API_URL}/wholesale/rebates/${id}`, getAuthHeaders());
  return response.data;
};

/**
 * Create a new rebate
 */
export const createRebate = async (data) => {
  const response = await axios.post(`${API_URL}/wholesale/rebates`, data, getAuthHeaders());
  return response.data;
};

/**
 * Update a rebate
 */
export const updateRebate = async (id, data) => {
  const response = await axios.put(`${API_URL}/wholesale/rebates/${id}`, data, getAuthHeaders());
  return response.data;
};

/**
 * Delete a rebate
 */
export const deleteRebate = async (id) => {
  const response = await axios.delete(`${API_URL}/wholesale/rebates/${id}`, getAuthHeaders());
  return response.data;
};

/**
 * Get available rebate periods for a company
 */
export const getAvailableRebatePeriods = async (companyId) => {
  const response = await axios.get(
    `${API_URL}/wholesale/companies/${companyId}/available-rebate-periods`,
    getAuthHeaders()
  );
  return response.data;
};

/**
 * Get rebate summary for income statement
 */
export const getRebateSummary = async (startDate, endDate) => {
  const response = await axios.get(
    `${API_URL}/wholesale/rebates/summary?start_date=${startDate}&end_date=${endDate}`,
    getAuthHeaders()
  );
  return response.data;
};
